import { ReactNode } from "react";

import { twJoin, twMerge } from "tailwind-merge";

type Props = {
  isActive?: boolean;
  className?: string;
  title: string;
  icon: ReactNode;
};

export const NavItem = (props: Props) => {
  const { isActive, className, title, icon } = props;

  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center opacity-50 transition-opacity",
        isActive && "opacity-100",
        className
      )}
    >
      {icon}
      <span
        className={twJoin(
          "mt-0.5 text-xs font-medium",
          isActive && "text-persianOrange"
        )}
      >
        {title}
      </span>
    </div>
  );
};
